import styled from 'styled-components';

export const PageContainer = styled.main`
  margin: 0 auto;
  max-width: 21cm;
  font-family: Arial, Helvetica, sans-serif;
  font-size: 12px;
  background: white;
  padding: 1cm;

  @media print {
    padding: 0.7cm 1cm 1cm 1cm;
    background-color: #fff;
  }
`;

export const LoadingImages = styled.div`
  width: 20px;
  height: 20px;
  border: 3px solid #fff;
  border-radius: 12px;
  border-bottom: 3px solid #1d4ed8;
  border-left: 3px solid #1d4ed8;
  animation: loading-animation 700ms infinite linear;

  @keyframes loading-animation {
    from {
      transform: rotate(0deg);
    }
    to {
      transform: rotate(360deg);
    }
  }
`;

export const ReportHeader = styled.header`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 24px;
  margin-bottom: 16px;
  padding-bottom: 8px;
  border-bottom: 1px solid #e5e7eb;

  .logo-wrapper {
    display: flex;
    align-items: center;
    gap: 8px;
  }

  img {
    max-height: 44px;
    width: auto;
  }

  .header-text {
    display: flex;
    flex-direction: column;
    align-items: flex-end;
    font-size: 10px;
    color: #4b5563;
  }
`;
